<onsip-queue-warnings-view [warning]="warning"></onsip-queue-warnings-view>
